/* eslint-disable */
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { loadLocaleMessages, setI18nLanguage, SUPPORT_LOCALES } from "@/i18n";
import store from "@/store";
import Home from "@/components/home/Home.vue";
import Login from "@/components/login/login.vue";
import Organization from "@/components/organization/organization.vue";
import Logs from "@/components/logs/Logs.vue";
import Roles from "@/components/roles/roles.vue";
import User from "@/components/Users/user.vue"; 
import Tenantlicense from "@/components/Tenant/tenant.vue";
import AppResource from "@/components/appresource/appresource.vue";
import Tenant from "@/components/Tenant/tenant.vue";

const DEFAULT_LOCALE = "en";

async function applyLocale(i18n: any) {
  const savedLocale = localStorage.getItem("lang") || DEFAULT_LOCALE;
  const locale = SUPPORT_LOCALES.includes(savedLocale)
    ? savedLocale
    : DEFAULT_LOCALE;
  const availableLocales = i18n.global.availableLocales || [];

  if (!availableLocales.includes(locale)) {
    await loadLocaleMessages(i18n, locale);
  }

  setI18nLanguage(i18n, locale);
}

function hasActiveSession() {
  const authData = store.getters.getAuthData || {};

  return Boolean(
    authData.token &&
      authData.tokenExp &&
      authData.timenow &&
      store.getters.isTokenActive
  );
}

function hasAuthHash(hash: string) {
  return (
    hash.includes("access_token=") ||
    hash.includes("id_token=") ||
    hash.includes("error=")
  );
}

export function setupRouter(i18n: any) {
  const routes: Array<RouteRecordRaw> = [
    {
      path: "/",
      name: "login",
      component: Login,
      meta: { publicOnly: true },
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
      meta: { requiredAuth: true },
    },
    {
      path: "/organization",
      name: "Organization",
      component: Organization,
      meta: { requiredAuth: true },
    },
    {
      path: "/tenant",
      name: "Tenant",
      component: Tenant,
      meta: { requiredAuth: true },
    },
    {
      path:"/roles",
      name:"Roles",
      component: Roles,
      meta: { requiredAuth: true },
    },
    {
      path:"/AdminModules",
      name:"AdminModule",
      component:Logs,
      meta: { requiredAuth: true },
    },
    
    {
      path:"/AppResource",
      name:"AppResource",
      component:AppResource,
      meta: { requiredAuth: true },
    },
    
    {
      path: "/:pathMatch(.*)*",
      redirect: () => (store.getters.authenticated ? "/home" : "/"),
    },
  ];

  const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
  });

  router.beforeEach(async (to) => {
    await applyLocale(i18n);
    window.scrollTo(0, 0);

    if (to.name !== "login" && hasAuthHash(to.hash || "")) {
      return { name: "login", hash: to.hash };
    }

    const authenticated = store.getters.authenticated;

    if (authenticated && !hasActiveSession()) {
      await store.dispatch("logoutuser");
      return { name: "login" };
    }

    if (to.meta.requiredAuth && !authenticated) {
      return { name: "login", query: { redirect: to.fullPath } };
    }

    if (to.meta.publicOnly && authenticated) {
      return { name: "Home" };
    }

    return true;
  });

  router.afterEach((to, from) => {
    store.dispatch("setPrevRoute", from && from.name ? from.name : null);
    store.dispatch("setNavbar", to.name !== "login");
  });

  return router;
}
